import _regeneratorRuntime from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
import t, { PureComponent as e, useRef as r, useEffect as n, isValidElement as o, useState as a, Fragment as i } from "react";
import { jsx as u, Fragment as c } from "react/jsx-runtime";
function s(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function f(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? s(Object(r), !0).forEach(function (e) {
      d(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }
  return t;
}
function l(t) {
  return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, l(t);
}
function p(t, e, r, n, o, a, i) {
  try {
    var u = t[a](i),
      c = u.value;
  } catch (t) {
    return void r(t);
  }
  u.done ? e(c) : Promise.resolve(c).then(n, o);
}
function y(t) {
  return function () {
    var e = this,
      r = arguments;
    return new Promise(function (n, o) {
      var a = t.apply(e, r);
      function i(t) {
        p(a, n, o, i, u, "next", t);
      }
      function u(t) {
        p(a, n, o, i, u, "throw", t);
      }
      i(void 0);
    });
  };
}
function v(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function d(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function b(t) {
  return b = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, b(t);
}
function h(t, e) {
  return h = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  }, h(t, e);
}
function m() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}
function g(t, e, r) {
  return g = m() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && h(o, r.prototype), o;
  }, g.apply(null, arguments);
}
function j(t, e) {
  if (null == t) return {};
  var r,
    n,
    o = function (t, e) {
      if (null == t) return {};
      var r,
        n,
        o = {},
        a = Object.keys(t);
      for (n = 0; n < a.length; n++) {
        r = a[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }
      return o;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (n = 0; n < a.length; n++) {
      r = a[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
    }
  }
  return o;
}
function w(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }(t);
}
function O(t, e) {
  return _(t) || function (t, e) {
    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == r) return;
    var n,
      o,
      a = [],
      i = !0,
      u = !1;
    try {
      for (r = r.call(t); !(i = (n = r.next()).done) && (a.push(n.value), !e || a.length !== e); i = !0) {
        ;
      }
    } catch (t) {
      u = !0, o = t;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (u) throw o;
      }
    }
    return a;
  }(t, e) || A(t, e) || T();
}
function x(t) {
  return _(t) || E(t) || A(t) || T();
}
function S(t) {
  return function (t) {
    if (Array.isArray(t)) return I(t);
  }(t) || E(t) || A(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function _(t) {
  if (Array.isArray(t)) return t;
}
function E(t) {
  if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
}
function A(t, e) {
  if (t) {
    if ("string" == typeof t) return I(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? I(t, e) : void 0;
  }
}
function I(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }
  return n;
}
function T() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function P(t) {
  var e = function (t, e) {
    if ("object" != typeof t || null === t) return t;
    var r = t[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(t, e || "default");
      if ("object" != typeof n) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
  }(t, "string");
  return "symbol" == typeof e ? e : String(e);
}
var k = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  R = {
    exports: {}
  },
  C = {
    exports: {}
  },
  $ = {},
  N = "function" == typeof Symbol && Symbol.for,
  M = N ? Symbol.for("react.element") : 60103,
  D = N ? Symbol.for("react.portal") : 60106,
  F = N ? Symbol.for("react.fragment") : 60107,
  U = N ? Symbol.for("react.strict_mode") : 60108,
  z = N ? Symbol.for("react.profiler") : 60114,
  V = N ? Symbol.for("react.provider") : 60109,
  B = N ? Symbol.for("react.context") : 60110,
  q = N ? Symbol.for("react.async_mode") : 60111,
  L = N ? Symbol.for("react.concurrent_mode") : 60111,
  W = N ? Symbol.for("react.forward_ref") : 60112,
  J = N ? Symbol.for("react.suspense") : 60113,
  K = N ? Symbol.for("react.suspense_list") : 60120,
  G = N ? Symbol.for("react.memo") : 60115,
  H = N ? Symbol.for("react.lazy") : 60116,
  Y = N ? Symbol.for("react.block") : 60121,
  Q = N ? Symbol.for("react.fundamental") : 60117,
  Z = N ? Symbol.for("react.responder") : 60118,
  X = N ? Symbol.for("react.scope") : 60119;
function tt(t) {
  if ("object" == typeof t && null !== t) {
    var e = t.$$typeof;
    switch (e) {
      case M:
        switch (t = t.type) {
          case q:
          case L:
          case F:
          case z:
          case U:
          case J:
            return t;
          default:
            switch (t = t && t.$$typeof) {
              case B:
              case W:
              case H:
              case G:
              case V:
                return t;
              default:
                return e;
            }
        }
      case D:
        return e;
    }
  }
}
function et(t) {
  return tt(t) === L;
}
$.AsyncMode = q, $.ConcurrentMode = L, $.ContextConsumer = B, $.ContextProvider = V, $.Element = M, $.ForwardRef = W, $.Fragment = F, $.Lazy = H, $.Memo = G, $.Portal = D, $.Profiler = z, $.StrictMode = U, $.Suspense = J, $.isAsyncMode = function (t) {
  return et(t) || tt(t) === q;
}, $.isConcurrentMode = et, $.isContextConsumer = function (t) {
  return tt(t) === B;
}, $.isContextProvider = function (t) {
  return tt(t) === V;
}, $.isElement = function (t) {
  return "object" == typeof t && null !== t && t.$$typeof === M;
}, $.isForwardRef = function (t) {
  return tt(t) === W;
}, $.isFragment = function (t) {
  return tt(t) === F;
}, $.isLazy = function (t) {
  return tt(t) === H;
}, $.isMemo = function (t) {
  return tt(t) === G;
}, $.isPortal = function (t) {
  return tt(t) === D;
}, $.isProfiler = function (t) {
  return tt(t) === z;
}, $.isStrictMode = function (t) {
  return tt(t) === U;
}, $.isSuspense = function (t) {
  return tt(t) === J;
}, $.isValidElementType = function (t) {
  return "string" == typeof t || "function" == typeof t || t === F || t === L || t === z || t === U || t === J || t === K || "object" == typeof t && null !== t && (t.$$typeof === H || t.$$typeof === G || t.$$typeof === V || t.$$typeof === B || t.$$typeof === W || t.$$typeof === Q || t.$$typeof === Z || t.$$typeof === X || t.$$typeof === Y);
}, $.typeOf = tt;
var rt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var t = "function" == typeof Symbol && Symbol.for,
    e = t ? Symbol.for("react.element") : 60103,
    r = t ? Symbol.for("react.portal") : 60106,
    n = t ? Symbol.for("react.fragment") : 60107,
    o = t ? Symbol.for("react.strict_mode") : 60108,
    a = t ? Symbol.for("react.profiler") : 60114,
    i = t ? Symbol.for("react.provider") : 60109,
    u = t ? Symbol.for("react.context") : 60110,
    c = t ? Symbol.for("react.async_mode") : 60111,
    s = t ? Symbol.for("react.concurrent_mode") : 60111,
    f = t ? Symbol.for("react.forward_ref") : 60112,
    l = t ? Symbol.for("react.suspense") : 60113,
    p = t ? Symbol.for("react.suspense_list") : 60120,
    y = t ? Symbol.for("react.memo") : 60115,
    v = t ? Symbol.for("react.lazy") : 60116,
    d = t ? Symbol.for("react.block") : 60121,
    b = t ? Symbol.for("react.fundamental") : 60117,
    h = t ? Symbol.for("react.responder") : 60118,
    m = t ? Symbol.for("react.scope") : 60119;
  function g(t) {
    if ("object" == typeof t && null !== t) {
      var p = t.$$typeof;
      switch (p) {
        case e:
          var d = t.type;
          switch (d) {
            case c:
            case s:
            case n:
            case a:
            case o:
            case l:
              return d;
            default:
              var b = d && d.$$typeof;
              switch (b) {
                case u:
                case f:
                case v:
                case y:
                case i:
                  return b;
                default:
                  return p;
              }
          }
        case r:
          return p;
      }
    }
  }
  var j = c,
    w = s,
    O = u,
    x = i,
    S = e,
    _ = f,
    E = n,
    A = v,
    I = y,
    T = r,
    P = a,
    k = o,
    R = l,
    C = !1;
  function $(t) {
    return g(t) === s;
  }
  rt.AsyncMode = j, rt.ConcurrentMode = w, rt.ContextConsumer = O, rt.ContextProvider = x, rt.Element = S, rt.ForwardRef = _, rt.Fragment = E, rt.Lazy = A, rt.Memo = I, rt.Portal = T, rt.Profiler = P, rt.StrictMode = k, rt.Suspense = R, rt.isAsyncMode = function (t) {
    return C || (C = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(t) || g(t) === c;
  }, rt.isConcurrentMode = $, rt.isContextConsumer = function (t) {
    return g(t) === u;
  }, rt.isContextProvider = function (t) {
    return g(t) === i;
  }, rt.isElement = function (t) {
    return "object" == typeof t && null !== t && t.$$typeof === e;
  }, rt.isForwardRef = function (t) {
    return g(t) === f;
  }, rt.isFragment = function (t) {
    return g(t) === n;
  }, rt.isLazy = function (t) {
    return g(t) === v;
  }, rt.isMemo = function (t) {
    return g(t) === y;
  }, rt.isPortal = function (t) {
    return g(t) === r;
  }, rt.isProfiler = function (t) {
    return g(t) === a;
  }, rt.isStrictMode = function (t) {
    return g(t) === o;
  }, rt.isSuspense = function (t) {
    return g(t) === l;
  }, rt.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === n || t === s || t === a || t === o || t === l || t === p || "object" == typeof t && null !== t && (t.$$typeof === v || t.$$typeof === y || t.$$typeof === i || t.$$typeof === u || t.$$typeof === f || t.$$typeof === b || t.$$typeof === h || t.$$typeof === m || t.$$typeof === d);
  }, rt.typeOf = g;
}(), "production" === process.env.NODE_ENV ? C.exports = $ : C.exports = rt
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/;
var nt = Object.getOwnPropertySymbols,
  ot = Object.prototype.hasOwnProperty,
  at = Object.prototype.propertyIsEnumerable;
function it(t) {
  if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
var ut = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
      for (var e = {}, r = 0; r < 10; r++) {
        e["_" + String.fromCharCode(r)] = r;
      }
      var n = Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      });
      if ("0123456789" !== n.join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        o[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var r, n, o = it(t), a = 1; a < arguments.length; a++) {
      for (var i in r = Object(arguments[a])) {
        ot.call(r, i) && (o[i] = r[i]);
      }
      if (nt) {
        n = nt(r);
        for (var u = 0; u < n.length; u++) {
          at.call(r, n[u]) && (o[n[u]] = r[n[u]]);
        }
      }
    }
    return o;
  },
  ct = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  st = Function.call.bind(Object.prototype.hasOwnProperty),
  ft = function ft() {};
if ("production" !== process.env.NODE_ENV) {
  var lt = ct,
    pt = {},
    yt = st;
  ft = function ft(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);
    try {
      throw new Error(e);
    } catch (t) {}
  };
}
function vt(t, e, r, n, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in t) {
    if (yt(t, a)) {
      var i;
      try {
        if ("function" != typeof t[a]) {
          var u = Error((n || "React class") + ": " + r + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw u.name = "Invariant Violation", u;
        }
        i = t[a](e, a, n, r, null, lt);
      } catch (t) {
        i = t;
      }
      if (!i || i instanceof Error || ft((n || "React class") + ": type specification of " + r + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in pt)) {
        pt[i.message] = !0;
        var c = o ? o() : "";
        ft("Failed " + r + " type: " + i.message + (null != c ? c : ""));
      }
    }
  }
}
vt.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (pt = {});
};
var dt = vt,
  bt = C.exports,
  ht = ut,
  mt = ct,
  gt = st,
  jt = dt,
  wt = function wt() {};
function Ot() {
  return null;
}
"production" !== process.env.NODE_ENV && (wt = function wt(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {}
});
function xt() {}
function St() {}
St.resetWarningCache = xt;
if ("production" !== process.env.NODE_ENV) {
  var _t = C.exports;
  R.exports = function (t, e) {
    var r = "function" == typeof Symbol && Symbol.iterator,
      n = "<<anonymous>>",
      o = {
        array: c("array"),
        bigint: c("bigint"),
        bool: c("boolean"),
        func: c("function"),
        number: c("number"),
        object: c("object"),
        string: c("string"),
        symbol: c("symbol"),
        any: u(Ot),
        arrayOf: function arrayOf(t) {
          return u(function (e, r, n, o, a) {
            if ("function" != typeof t) return new i("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
            var u = e[r];
            if (!Array.isArray(u)) return new i("Invalid " + o + " `" + a + "` of type `" + l(u) + "` supplied to `" + n + "`, expected an array.");
            for (var c = 0; c < u.length; c++) {
              var s = t(u, c, n, o, a + "[" + c + "]", mt);
              if (s instanceof Error) return s;
            }
            return null;
          });
        },
        element: u(function (e, r, n, o, a) {
          var u = e[r];
          return t(u) ? null : new i("Invalid " + o + " `" + a + "` of type `" + l(u) + "` supplied to `" + n + "`, expected a single ReactElement.");
        }),
        elementType: u(function (t, e, r, n, o) {
          var a = t[e];
          return bt.isValidElementType(a) ? null : new i("Invalid " + n + " `" + o + "` of type `" + l(a) + "` supplied to `" + r + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(t) {
          return u(function (e, r, o, a, u) {
            if (!(e[r] instanceof t)) {
              var c = t.name || n;
              return new i("Invalid " + a + " `" + u + "` of type `" + ((s = e[r]).constructor && s.constructor.name ? s.constructor.name : n) + "` supplied to `" + o + "`, expected instance of `" + c + "`.");
            }
            var s;
            return null;
          });
        },
        node: u(function (t, e, r, n, o) {
          return f(t[e]) ? null : new i("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(t) {
          return u(function (e, r, n, o, a) {
            if ("function" != typeof t) return new i("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
            var u = e[r],
              c = l(u);
            if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + n + "`, expected an object.");
            for (var s in u) {
              if (gt(u, s)) {
                var f = t(u, s, n, o, a + "." + s, mt);
                if (f instanceof Error) return f;
              }
            }
            return null;
          });
        },
        oneOf: function oneOf(t) {
          if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && wt(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), Ot;
          function e(e, r, n, o, u) {
            for (var c = e[r], s = 0; s < t.length; s++) {
              if (a(c, t[s])) return null;
            }
            var f = JSON.stringify(t, function (t, e) {
              return "symbol" === p(e) ? String(e) : e;
            });
            return new i("Invalid " + o + " `" + u + "` of value `" + String(c) + "` supplied to `" + n + "`, expected one of " + f + ".");
          }
          return u(e);
        },
        oneOfType: function oneOfType(t) {
          if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && wt("Invalid argument supplied to oneOfType, expected an instance of array."), Ot;
          for (var e = 0; e < t.length; e++) {
            var r = t[e];
            if ("function" != typeof r) return wt("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + y(r) + " at index " + e + "."), Ot;
          }
          return u(function (e, r, n, o, a) {
            for (var u = [], c = 0; c < t.length; c++) {
              var s = (0, t[c])(e, r, n, o, a, mt);
              if (null == s) return null;
              s.data && gt(s.data, "expectedType") && u.push(s.data.expectedType);
            }
            return new i("Invalid " + o + " `" + a + "` supplied to `" + n + "`" + (u.length > 0 ? ", expected one of type [" + u.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(t) {
          return u(function (e, r, n, o, a) {
            var u = e[r],
              c = l(u);
            if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + n + "`, expected `object`.");
            for (var f in t) {
              var y = t[f];
              if ("function" != typeof y) return s(n, o, a, f, p(y));
              var v = y(u, f, n, o, a + "." + f, mt);
              if (v) return v;
            }
            return null;
          });
        },
        exact: function exact(t) {
          return u(function (e, r, n, o, a) {
            var u = e[r],
              c = l(u);
            if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + n + "`, expected `object`.");
            var f = ht({}, e[r], t);
            for (var y in f) {
              var v = t[y];
              if (gt(t, y) && "function" != typeof v) return s(n, o, a, y, p(v));
              if (!v) return new i("Invalid " + o + " `" + a + "` key `" + y + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(e[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
              var d = v(u, y, n, o, a + "." + y, mt);
              if (d) return d;
            }
            return null;
          });
        }
      };
    function a(t, e) {
      return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    }
    function i(t, e) {
      this.message = t, this.data = e && "object" == typeof e ? e : {}, this.stack = "";
    }
    function u(t) {
      if ("production" !== process.env.NODE_ENV) var r = {},
        o = 0;
      function a(a, u, c, s, f, l, p) {
        if (s = s || n, l = l || c, p !== mt) {
          if (e) {
            var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw y.name = "Invariant Violation", y;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var v = s + ":" + c;
            !r[v] && o < 3 && (wt("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[v] = !0, o++);
          }
        }
        return null == u[c] ? a ? null === u[c] ? new i("The " + f + " `" + l + "` is marked as required in `" + s + "`, but its value is `null`.") : new i("The " + f + " `" + l + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : t(u, c, s, f, l);
      }
      var u = a.bind(null, !1);
      return u.isRequired = a.bind(null, !0), u;
    }
    function c(t) {
      return u(function (e, r, n, o, a, u) {
        var c = e[r];
        return l(c) !== t ? new i("Invalid " + o + " `" + a + "` of type `" + p(c) + "` supplied to `" + n + "`, expected `" + t + "`.", {
          expectedType: t
        }) : null;
      });
    }
    function s(t, e, r, n, o) {
      return new i((t || "React class") + ": " + e + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
    }
    function f(e) {
      switch (typeof e) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !e;
        case "object":
          if (Array.isArray(e)) return e.every(f);
          if (null === e || t(e)) return !0;
          var n = function (t) {
            var e = t && (r && t[r] || t["@@iterator"]);
            if ("function" == typeof e) return e;
          }(e);
          if (!n) return !1;
          var o,
            a = n.call(e);
          if (n !== e.entries) {
            for (; !(o = a.next()).done;) {
              if (!f(o.value)) return !1;
            }
          } else for (; !(o = a.next()).done;) {
            var i = o.value;
            if (i && !f(i[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function l(t) {
      var e = typeof t;
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
        return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
      }(e, t) ? "symbol" : e;
    }
    function p(t) {
      if (null == t) return "" + t;
      var e = l(t);
      if ("object" === e) {
        if (t instanceof Date) return "date";
        if (t instanceof RegExp) return "regexp";
      }
      return e;
    }
    function y(t) {
      var e = p(t);
      switch (e) {
        case "array":
        case "object":
          return "an " + e;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + e;
        default:
          return e;
      }
    }
    return i.prototype = Error.prototype, o.checkPropTypes = jt, o.resetWarningCache = jt.resetWarningCache, o.PropTypes = o, o;
  }(_t.isElement, !0);
} else R.exports = function () {
  function t(t, e, r, n, o, a) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) {
      var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i.name = "Invariant Violation", i;
    }
  }
  function e() {
    return t;
  }
  t.isRequired = t;
  var r = {
    array: t,
    bigint: t,
    bool: t,
    func: t,
    number: t,
    object: t,
    string: t,
    symbol: t,
    any: t,
    arrayOf: e,
    element: t,
    elementType: t,
    instanceOf: e,
    node: t,
    objectOf: e,
    oneOf: e,
    oneOfType: e,
    shape: e,
    exact: e,
    checkPropTypes: St,
    resetWarningCache: xt
  };
  return r.PropTypes = r, r;
}();
var Et = R.exports,
  At = Array.isArray,
  It = "object" == typeof k && k && k.Object === Object && k,
  Tt = It,
  Pt = "object" == typeof self && self && self.Object === Object && self,
  kt = Tt || Pt || Function("return this")(),
  Rt = kt.Symbol,
  Ct = Rt,
  $t = Object.prototype,
  Nt = $t.hasOwnProperty,
  Mt = $t.toString,
  Dt = Ct ? Ct.toStringTag : void 0;
var Ft = function Ft(t) {
    var e = Nt.call(t, Dt),
      r = t[Dt];
    try {
      t[Dt] = void 0;
      var n = !0;
    } catch (t) {}
    var o = Mt.call(t);
    return n && (e ? t[Dt] = r : delete t[Dt]), o;
  },
  Ut = Object.prototype.toString;
var zt = Ft,
  Vt = function Vt(t) {
    return Ut.call(t);
  },
  Bt = Rt ? Rt.toStringTag : void 0;
var qt = function qt(t) {
  return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : Bt && Bt in Object(t) ? zt(t) : Vt(t);
};
var Lt = function Lt(t) {
    return null != t && "object" == typeof t;
  },
  Wt = qt,
  Jt = Lt;
var Kt = function Kt(t) {
    return "symbol" == typeof t || Jt(t) && "[object Symbol]" == Wt(t);
  },
  Gt = At,
  Ht = Kt,
  Yt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  Qt = /^\w*$/;
var Zt = function Zt(t, e) {
  if (Gt(t)) return !1;
  var r = typeof t;
  return !("number" != r && "symbol" != r && "boolean" != r && null != t && !Ht(t)) || Qt.test(t) || !Yt.test(t) || null != e && t in Object(e);
};
var Xt = function Xt(t) {
    var e = typeof t;
    return null != t && ("object" == e || "function" == e);
  },
  te = qt,
  ee = Xt;
var re,
  ne = function ne(t) {
    if (!ee(t)) return !1;
    var e = te(t);
    return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
  },
  oe = kt["__core-js_shared__"],
  ae = (re = /[^.]+$/.exec(oe && oe.keys && oe.keys.IE_PROTO || "")) ? "Symbol(src)_1." + re : "";
var ie = function ie(t) {
    return !!ae && ae in t;
  },
  ue = Function.prototype.toString;
var ce = function ce(t) {
    if (null != t) {
      try {
        return ue.call(t);
      } catch (t) {}
      try {
        return t + "";
      } catch (t) {}
    }
    return "";
  },
  se = ne,
  fe = ie,
  le = Xt,
  pe = ce,
  ye = /^\[object .+?Constructor\]$/,
  ve = Function.prototype,
  de = Object.prototype,
  be = ve.toString,
  he = de.hasOwnProperty,
  me = RegExp("^" + be.call(he).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var ge = function ge(t) {
    return !(!le(t) || fe(t)) && (se(t) ? me : ye).test(pe(t));
  },
  je = function je(t, e) {
    return null == t ? void 0 : t[e];
  };
var we = function we(t, e) {
    var r = je(t, e);
    return ge(r) ? r : void 0;
  },
  Oe = we(Object, "create"),
  xe = Oe;
var Se = function Se() {
  this.__data__ = xe ? xe(null) : {}, this.size = 0;
};
var _e = function _e(t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
  },
  Ee = Oe,
  Ae = Object.prototype.hasOwnProperty;
var Ie = function Ie(t) {
    var e = this.__data__;
    if (Ee) {
      var r = e[t];
      return "__lodash_hash_undefined__" === r ? void 0 : r;
    }
    return Ae.call(e, t) ? e[t] : void 0;
  },
  Te = Oe,
  Pe = Object.prototype.hasOwnProperty;
var ke = Oe;
var Re = Se,
  Ce = _e,
  $e = Ie,
  Ne = function Ne(t) {
    var e = this.__data__;
    return Te ? void 0 !== e[t] : Pe.call(e, t);
  },
  Me = function Me(t, e) {
    var r = this.__data__;
    return this.size += this.has(t) ? 0 : 1, r[t] = ke && void 0 === e ? "__lodash_hash_undefined__" : e, this;
  };
function De(t) {
  var e = -1,
    r = null == t ? 0 : t.length;
  for (this.clear(); ++e < r;) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
De.prototype.clear = Re, De.prototype.delete = Ce, De.prototype.get = $e, De.prototype.has = Ne, De.prototype.set = Me;
var Fe = De;
var Ue = function Ue() {
  this.__data__ = [], this.size = 0;
};
var ze = function ze(t, e) {
    return t === e || t != t && e != e;
  },
  Ve = ze;
var Be = function Be(t, e) {
    for (var r = t.length; r--;) {
      if (Ve(t[r][0], e)) return r;
    }
    return -1;
  },
  qe = Be,
  Le = Array.prototype.splice;
var We = Be;
var Je = Be;
var Ke = Be;
var Ge = Ue,
  He = function He(t) {
    var e = this.__data__,
      r = qe(e, t);
    return !(r < 0) && (r == e.length - 1 ? e.pop() : Le.call(e, r, 1), --this.size, !0);
  },
  Ye = function Ye(t) {
    var e = this.__data__,
      r = We(e, t);
    return r < 0 ? void 0 : e[r][1];
  },
  Qe = function Qe(t) {
    return Je(this.__data__, t) > -1;
  },
  Ze = function Ze(t, e) {
    var r = this.__data__,
      n = Ke(r, t);
    return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
  };
function Xe(t) {
  var e = -1,
    r = null == t ? 0 : t.length;
  for (this.clear(); ++e < r;) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Xe.prototype.clear = Ge, Xe.prototype.delete = He, Xe.prototype.get = Ye, Xe.prototype.has = Qe, Xe.prototype.set = Ze;
var tr = Xe,
  er = we(kt, "Map"),
  rr = Fe,
  nr = tr,
  or = er;
var ar = function ar(t) {
  var e = typeof t;
  return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
};
var ir = function ir(t, e) {
    var r = t.__data__;
    return ar(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
  },
  ur = ir;
var cr = ir;
var sr = ir;
var fr = ir;
var lr = function lr() {
    this.size = 0, this.__data__ = {
      hash: new rr(),
      map: new (or || nr)(),
      string: new rr()
    };
  },
  pr = function pr(t) {
    var e = ur(this, t).delete(t);
    return this.size -= e ? 1 : 0, e;
  },
  yr = function yr(t) {
    return cr(this, t).get(t);
  },
  vr = function vr(t) {
    return sr(this, t).has(t);
  },
  dr = function dr(t, e) {
    var r = fr(this, t),
      n = r.size;
    return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
  };
function br(t) {
  var e = -1,
    r = null == t ? 0 : t.length;
  for (this.clear(); ++e < r;) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
br.prototype.clear = lr, br.prototype.delete = pr, br.prototype.get = yr, br.prototype.has = vr, br.prototype.set = dr;
var hr = br,
  mr = hr;
function gr(t, e) {
  if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
  var r = function r() {
    var n = arguments,
      o = e ? e.apply(this, n) : n[0],
      a = r.cache;
    if (a.has(o)) return a.get(o);
    var i = t.apply(this, n);
    return r.cache = a.set(o, i) || a, i;
  };
  return r.cache = new (gr.Cache || mr)(), r;
}
gr.Cache = mr;
var jr = gr;
var wr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  Or = /\\(\\)?/g,
  xr = function (t) {
    var e = jr(t, function (t) {
        return 500 === r.size && r.clear(), t;
      }),
      r = e.cache;
    return e;
  }(function (t) {
    var e = [];
    return 46 === t.charCodeAt(0) && e.push(""), t.replace(wr, function (t, r, n, o) {
      e.push(n ? o.replace(Or, "$1") : r || t);
    }), e;
  });
var Sr = function Sr(t, e) {
    for (var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;) {
      o[r] = e(t[r], r, t);
    }
    return o;
  },
  _r = Sr,
  Er = At,
  Ar = Kt,
  Ir = Rt ? Rt.prototype : void 0,
  Tr = Ir ? Ir.toString : void 0;
var Pr = function t(e) {
    if ("string" == typeof e) return e;
    if (Er(e)) return _r(e, t) + "";
    if (Ar(e)) return Tr ? Tr.call(e) : "";
    var r = e + "";
    return "0" == r && 1 / e == -Infinity ? "-0" : r;
  },
  kr = Pr;
var Rr = At,
  Cr = Zt,
  $r = xr,
  Nr = function Nr(t) {
    return null == t ? "" : kr(t);
  };
var Mr = function Mr(t, e) {
    return Rr(t) ? t : Cr(t, e) ? [t] : $r(Nr(t));
  },
  Dr = Kt;
var Fr = function Fr(t) {
    if ("string" == typeof t || Dr(t)) return t;
    var e = t + "";
    return "0" == e && 1 / t == -Infinity ? "-0" : e;
  },
  Ur = Mr,
  zr = Fr;
var Vr = function Vr(t, e) {
    for (var r = 0, n = (e = Ur(e, t)).length; null != t && r < n;) {
      t = t[zr(e[r++])];
    }
    return r && r == n ? t : void 0;
  },
  Br = Vr;
var qr = function qr(t, e, r) {
  var n = null == t ? void 0 : Br(t, e);
  return void 0 === n ? r : n;
};
function Lr(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var Wr;
Wr = function Wr(t, e, r, n) {
  e = e || "&", r = r || "=";
  var o = {};
  if ("string" != typeof t || 0 === t.length) return o;
  var a = /\+/g;
  t = t.split(e);
  var i = 1e3;
  n && "number" == typeof n.maxKeys && (i = n.maxKeys);
  var u = t.length;
  i > 0 && u > i && (u = i);
  for (var c = 0; c < u; ++c) {
    var s,
      f,
      l,
      p,
      y = t[c].replace(a, "%20"),
      v = y.indexOf(r);
    v >= 0 ? (s = y.substr(0, v), f = y.substr(v + 1)) : (s = y, f = ""), l = decodeURIComponent(s), p = decodeURIComponent(f), Lr(o, l) ? Array.isArray(o[l]) ? o[l].push(p) : o[l] = [o[l], p] : o[l] = p;
  }
  return o;
};
var Jr = function Jr() {
    return "undefined" != typeof window;
  },
  Kr = function Kr() {
    var t = Jr ? window.location.search.substring(1) : "";
    return Wr(t) || {};
  },
  Gr = function Gr(t) {
    var e = t.text,
      r = void 0 === e ? "" : e,
      n = t.fn,
      o = t.regex,
      a = new RegExp("{".concat(void 0 === o ? "\\w+" : o, "}"), "gi");
    return r.replace(a, n);
  },
  Hr = function Hr(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "\\w+",
      n = new RegExp("{(".concat(r, ")}")),
      o = t.match(n),
      a = O(o, 2),
      i = a[1],
      u = e[i.trim()];
    return u || t;
  },
  Yr = function Yr(t) {
    return Hr(t, Kr());
  },
  Qr = function Qr(t) {
    return Promise.all(t);
  },
  Zr = function Zr() {
    var t,
      e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      r = e.mapComponents,
      n = e.addImports,
      o = e.customComponents,
      a = e.importComponents,
      i = void 0 === a ? {
        dlsComponents: "*"
      } : a,
      u = e.currentModule,
      c = void 0 === u ? "dlsComponents" : u,
      s = n && Array.isArray(n) ? [import("@dls/web")].concat(S(n)) : [import("@dls/web")];
    return (t = Qr(s)) && t.then(function (t) {
      var e = x(t),
        n = e[0],
        a = e.slice(1),
        u = Kn(d({}, c, n), i),
        s = Jn(r, u),
        l = a.reduce(function (t, e) {
          return f(f({}, t), e);
        }, {});
      return f(f(f(f({}, u), l), s), o);
    });
  },
  Xr = function Xr(t) {
    return t && "Object" === t.constructor.name;
  },
  tn = function tn(t) {
    return !1 === Xr(t);
  },
  en = function en(t) {
    return "string" != typeof t ? JSON.stringify(t) : t;
  },
  rn = function rn(t) {
    return Object.keys(t).map(function (e) {
      return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
    }).join("&");
  },
  nn = function nn(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16;
    return t / e + "rem";
  },
  on = function on(t) {
    var e = t.replace("#", "");
    return {
      r: parseInt(e.slice(0, 2), 16),
      g: parseInt(e.slice(2, 4), 16),
      b: parseInt(e.slice(4, 6), 16),
      a: 0 === e.slice(6, 8).length ? 1 : +(parseInt(e.slice(6, 8), 16) / 255).toFixed(2)
    };
  },
  an = function an(t, e) {
    return (e ? "#" : "") + [t.r.toString(16), t.g.toString(16), t.b.toString(16), Math.round(255 * t.a).toString(16)].map(function (t) {
      return 1 === t.length ? "0" + t : t;
    }).join("").toUpperCase();
  },
  un = function un(t, e) {
    var r = t.r + t.r / 100 * (1 + e),
      n = t.g + t.g / 100 * (1 + e),
      o = t.b + t.b / 100 * (1 + e);
    return {
      r: r < 256 ? r : 255,
      g: n < 256 ? n : 255,
      b: o < 256 ? o : 255,
      a: t.a
    };
  },
  cn = function cn() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.search,
      e = /[?&]/.test(t) ? t.slice(t.indexOf("?") + 1).split("&") : [];
    return e.filter(function (t) {
      return t;
    }).reduce(function (t, e) {
      var r = O(e.split("="), 2),
        n = r[0],
        o = r[1];
      return t[n] = o && decodeURIComponent(o) || "", t;
    }, {});
  },
  sn = function sn(t, e) {
    var r = t.split("#")[0],
      n = t.split("#")[1],
      o = Object.assign(cn(r), e),
      a = Object.keys(o).map(function (t) {
        return [t, o[t]].map(encodeURIComponent).join("=");
      }).join("&"),
      i = n ? "#".concat(n) : "";
    return (a ? [r.split("?")[0], a].join("?") : r.split("?")[0]) + i;
  },
  fn = function fn(t) {
    return 13 === t.which || 13 === t.keyCode || 13 === parseInt(t.key);
  },
  ln = function ln(t) {
    return "Escape" === t.key || "Esc" === t.key;
  },
  pn = function pn(t) {
    return t.indexOf("://") > 0 || 0 === t.indexOf("//");
  };
function yn(t) {
  var e,
    r = arguments,
    n = this,
    o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100;
  return function () {
    var a = n,
      i = r;
    clearTimeout(e), e = setTimeout(function () {
      return t.apply(a, i);
    }, o);
  };
}
var vn = function vn(t) {
    try {
      return JSON.parse(t);
    } catch (t) {
      return {};
    }
  },
  dn = function dn() {},
  bn = ["href"];
function hn(t) {
  return t && "object" === l(t) && "default" in t ? t.default : t;
}
var mn = hn(require("posthtml-parser")),
  gn = hn(require("react")),
  jn = hn(require("lodash/get")),
  wn = require("html-entities");
function On(t) {
  return t.replace(/(-|:)(.)/g, function (t, e, r) {
    return r.toUpperCase();
  });
}
function xn(t) {
  var e = {};
  return t.split(";").filter(function (t) {
    return "" !== t.trim();
  }).forEach(function (t) {
    var r,
      n = t.split(":");
    if (n.length > 1) {
      var o = function (t) {
          return /^-ms-/.test(t) && (t = t.substr(1)), On(t);
        }(n[0].trim()),
        a = (r = n.slice(1).join(":").trim(), /^\d+$/.test(r) ? Number(r) : r.replace(/'/g, '"'));
      e[o] = a;
    }
  }), e;
}
var Sn = {
    for: "htmlFor",
    class: "className",
    acceptcharset: "acceptCharset",
    accesskey: "accessKey",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classID",
    classname: "className",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    datetime: "dateTime",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    htmlfor: "htmlFor",
    httpequiv: "httpEquiv",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap"
  },
  _n = new RegExp("Android|iPad|iPhone|iPod", "i"),
  En = "object" === ("undefined" == typeof navigator ? "undefined" : l(navigator)) && _n.test(navigator.userAgent);
function An(t) {
  var e = en(t);
  return "function" == typeof t ? t : new Function("isMobile", "return " + e.trim())(En);
}
function In(t) {
  var e = t.attrs,
    r = function (t) {
      var e = t.attrs,
        r = t.options,
        n = t.userInputData;
      if (e) {
        if (e.href) return Pn(e.href, r, n);
        if (e.onClick) return O(en(e.onClick).match(/window\.(location\.assign|open)\([\\'|\\"]([^,]*)[\\'|\\"]/), 3)[2];
      }
      return "#";
    }({
      attrs: e,
      options: t.options,
      userInputData: t.userInputData
    });
  return e.href, f(f({}, j(e, bn)), {}, {
    onClick: function onClick(t) {
      if (t.preventDefault(), console.log("isBrowser", Jr), Jr) return window.ReactNativeWebView.postMessage(JSON.stringify({
        action: "HANDLE_LINK_NATIVE",
        url: r
      }));
    }
  });
}
function Tn(t) {
  var e = t.tag,
    r = t.attrs,
    n = t.options,
    o = t.userInputData;
  return function (t) {
    var e = t.tag,
      r = t.attrs;
    if (Jr) {
      var n = qr(window, "ReactNativeWebView.postMessage");
      return r && (r.href || r.onClick) && "a" === e && n && "function" == typeof n;
    }
  }({
    tag: e,
    attrs: r
  }) ? In({
    attrs: r,
    options: n,
    userInputData: o
  }) : r;
}
function Pn(t, e, r) {
  if ($n(t)) {
    var n = function (t, e) {
      return O(t.match(e) || [], 2)[1];
    }(t, Nn);
    if (void 0 !== r[n]) return function (t, e, r) {
      if ("string" == typeof r[t]) {
        var n = Gr({
          text: r[t],
          fn: Yr
        });
        return Gn(n, e, r);
      }
      return r[t];
    }(n, e, r);
  }
  return kn.includes(t) || Cn(t) ? JSON.parse(t) : t;
}
var kn = ["true", "false"],
  Rn = /(^[-]?\d+\.\d*$)|(^[-]?\d+$)/,
  Cn = function Cn(t) {
    return Rn.test(t);
  };
function $n(t) {
  return Nn.test(t);
}
var Nn = new RegExp("{(.*\\w)}");
function Mn(t) {
  switch (l(t)) {
    case "string":
      return mn.parser(t.trim());
    case "number":
      return [t.toString()];
    default:
      return Array.isArray(t) ? t : [];
  }
}
function Dn(t, e) {
  var r = t.split("{"),
    n = [];
  return r.forEach(function (t, r) {
    var o = function (t, e, r) {
      var n = t.match(/^([\w\\.]+)}/);
      if (n) {
        var o = e[O(n, 2)[1]];
        if (void 0 !== o) {
          var a;
          a = S(Mn(o));
          var i = O(t.match(/^[\w\\.]+}(.*)/), 2)[1];
          return i && (a = [].concat(S(a), [i])), a;
        }
      }
      var u = t;
      return r >= 1 && (u = "{" + t), [u];
    }(t, e, r);
    n = [].concat(S(n), S(o));
  }), n;
}
function Fn(t, e) {
  return t ? t.reduce(function (t, r) {
    return "string" != typeof r || !1 === $n(r) ? [].concat(S(t), [r]) : [].concat(S(t), S(Dn(r, e)));
  }, []) : t;
}
var Un = ["table", "tbody", "thead", "tfoot", "tr"];
function zn(t, e, r, n) {
  var o = r.map._;
  if ("string" == typeof t) {
    var a = Gr({
        text: t,
        fn: Yr
      }),
      i = a.trim();
    if (/^<!--[\s\S]+-->/.test(i)) return null;
    var u = wn.decode(a);
    return o ? o(u) : u;
  }
  var c = Fn(t.content, n),
    s = t.tag,
    f = t.attrs,
    l = c,
    p = r.map[s];
  f && Object.keys(f).forEach(function (t) {
    f[t] = wn.decode(f[t]);
  });
  var y = Object.assign({}, function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      e = arguments[1],
      r = e.tag,
      n = e.options,
      o = e.userInputData,
      a = Tn({
        tag: r,
        attrs: t,
        options: n,
        userInputData: o
      });
    return Object.keys(a).reduce(function (t, e) {
      if (/^on.*/.test(e)) {
        var r = a[e];
        return t[e] = An(r), t;
      }
      var i = e;
      /^(data|aria)-/.test(e) || (i = On(e));
      var u = Pn(a[e], n, o),
        c = Sn[i] || i;
      return t[c] = "style" === c ? xn(a.style) : u, t;
    }, {});
  }(f, {
    tag: s,
    options: r,
    userInputData: n
  }), {
    key: e
  });
  if ("style" === s && !p && !o) return y.dangerouslySetInnerHTML = {
    __html: l[0]
  }, gn.createElement(s, y, null);
  var v = void 0 === l ? null : l.map(function (t, o) {
    return Un.indexOf(s) > -1 && "string" == typeof t && "" === (t = t.trim()) ? null : zn(t, e + "." + o, r, n);
  }).filter(function (t) {
    return null !== t;
  });
  return v && 0 === v.length && (v = null), p ? gn.createElement(p, y, v) : o ? o(s, y, v) : gn.createElement(s, y, v);
}
var Vn = function Vn(t) {
  var e = t.content,
    r = t.userInputData,
    n = e.match(/{(.*?)}/g);
  return n ? n.reduce(function (t, e) {
    var n = e.substring(1, e.length - 1),
      o = jn(r, n) || e;
    return t.replace.apply(t, [e].concat(S(Mn(o))));
  }, e) : e;
};
function Bn(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    n = {
      map: e.map || {}
    },
    o = mn.parser(t.trim()),
    a = Fn(o, r),
    i = a.map(function (t, e) {
      return zn(t, e.toString(), n, r);
    }).filter(function (t) {
      return null !== t;
    });
  return i.length > 1 ? i : i[0];
}
var qn = function qn(t, e) {
    return e[t], {
      userInputData: j(e, [t].map(P))
    };
  },
  Ln = function Ln(t, e) {
    return "*" === t ? Object.keys(e) : Array.isArray(t) ? t : [];
  },
  Wn = function Wn() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
      r = Ln(e, t);
    return r.reduce(function (e, r) {
      return f(f({}, e), {}, d({}, r, qr(t, r)));
    }, {});
  },
  Jn = function Jn(t, e) {
    var r = {};
    for (var n in t) {
      var o = t[n];
      r = f(f({}, r), {}, d({}, n, qr(e, o)));
    }
    return r;
  },
  Kn = function Kn() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = Object.keys(e);
    return r.reduce(function (r, n) {
      var o = Wn(t[n], e[n]);
      return f(f({}, r), o);
    }, {});
  },
  Gn = function Gn(e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return Bn(e, {
      map: f(f({}, r), {}, {
        _: function _(e, r, n) {
          return "script" === e || "style" === e ? null : void 0 === r ? e : t.createElement(e, r, n);
        }
      })
    }, n);
  },
  Hn = d({}, ["richText"][0], Et.string.isRequired),
  Yn = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e && h(t, e);
    }(l, e);
    var r,
      n,
      o,
      a,
      i,
      s,
      f = (r = l, n = m(), function () {
        var t,
          e = b(r);
        if (n) {
          var o = b(this).constructor;
          t = Reflect.construct(e, arguments, o);
        } else t = e.apply(this, arguments);
        return w(this, t);
      });
    function l(t) {
      var e;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, l), (e = f.call(this, t)).state = {}, e;
    }
    return o = l, a = [{
      key: "componentDidMount",
      value: (s = y(_regeneratorRuntime.mark(function t() {
        var e, r, n, o, a, i, u, c;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (e = this.state.template, !(n = (r = void 0 === e ? {} : e).richText)) {
                  t.next = 13;
                  break;
                }
                if (o = this.props.componentsToMap, t.t0 = o, !t.t0) {
                  t.next = 9;
                  break;
                }
                return t.next = 8, o;
              case 8:
                t.t0 = t.sent;
              case 9:
                a = t.t0, i = qn("richText", r), u = i.userInputData, c = Gn(n, a, u), this.setState({
                  richTextWithComponents: c
                });
              case 13:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function () {
        return s.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var t = this.state.richTextWithComponents;
        return t ? u(c, {
          children: t
        }) : null;
      }
    }], i = [{
      key: "getDerivedStateFromProps",
      value: function value(t) {
        var e = t.htmlString,
          r = t.componentsToMap,
          n = t.userInputData,
          o = t.templates,
          a = void 0 === o ? {} : o,
          i = t.templateKey,
          u = t.template;
        return e ? {
          richTextWithComponents: Gn(e, r, n)
        } : {
          template: a[i] || a.default || u
        };
      }
    }], a && v(o.prototype, a), i && v(o, i), Object.defineProperty(o, "prototype", {
      writable: !1
    }), l;
  }();
Yn.propTypes = {
  template: Et.shape(f({}, Hn)),
  templates: Et.object,
  templateKey: Et.string,
  componentsToMap: Et.object,
  htmlString: Et.string,
  userInputData: Et.object
}, Yn.defaultProps = {};
var Qn = tr;
var Zn = tr,
  Xn = er,
  to = hr;
var eo = tr,
  ro = function ro() {
    this.__data__ = new Qn(), this.size = 0;
  },
  no = function no(t) {
    var e = this.__data__,
      r = e.delete(t);
    return this.size = e.size, r;
  },
  oo = function oo(t) {
    return this.__data__.get(t);
  },
  ao = function ao(t) {
    return this.__data__.has(t);
  },
  io = function io(t, e) {
    var r = this.__data__;
    if (r instanceof Zn) {
      var n = r.__data__;
      if (!Xn || n.length < 199) return n.push([t, e]), this.size = ++r.size, this;
      r = this.__data__ = new to(n);
    }
    return r.set(t, e), this.size = r.size, this;
  };
function uo(t) {
  var e = this.__data__ = new eo(t);
  this.size = e.size;
}
uo.prototype.clear = ro, uo.prototype.delete = no, uo.prototype.get = oo, uo.prototype.has = ao, uo.prototype.set = io;
var co = uo;
var so = function so(t, e) {
    for (var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r, t);) {
      ;
    }
    return t;
  },
  fo = we,
  lo = function () {
    try {
      var t = fo(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch (t) {}
  }(),
  po = lo;
var yo = function yo(t, e, r) {
    "__proto__" == e && po ? po(t, e, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : t[e] = r;
  },
  vo = yo,
  bo = ze,
  ho = Object.prototype.hasOwnProperty;
var mo = function mo(t, e, r) {
    var n = t[e];
    ho.call(t, e) && bo(n, r) && (void 0 !== r || e in t) || vo(t, e, r);
  },
  go = mo,
  jo = yo;
var wo = function wo(t, e, r, n) {
  var o = !r;
  r || (r = {});
  for (var a = -1, i = e.length; ++a < i;) {
    var u = e[a],
      c = n ? n(r[u], t[u], u, r, t) : void 0;
    void 0 === c && (c = t[u]), o ? jo(r, u, c) : go(r, u, c);
  }
  return r;
};
var Oo = function Oo(t, e) {
    for (var r = -1, n = Array(t); ++r < t;) {
      n[r] = e(r);
    }
    return n;
  },
  xo = qt,
  So = Lt;
var _o = function _o(t) {
    return So(t) && "[object Arguments]" == xo(t);
  },
  Eo = Lt,
  Ao = Object.prototype,
  Io = Ao.hasOwnProperty,
  To = Ao.propertyIsEnumerable,
  Po = _o(function () {
    return arguments;
  }()) ? _o : function (t) {
    return Eo(t) && Io.call(t, "callee") && !To.call(t, "callee");
  },
  ko = {
    exports: {}
  };
var Ro = function Ro() {
  return !1;
};
!function (t, e) {
  var r = kt,
    n = Ro,
    o = e && !e.nodeType && e,
    a = o && t && !t.nodeType && t,
    i = a && a.exports === o ? r.Buffer : void 0,
    u = (i ? i.isBuffer : void 0) || n;
  t.exports = u;
}(ko, ko.exports);
var Co = /^(?:0|[1-9]\d*)$/;
var $o = function $o(t, e) {
  var r = typeof t;
  return !!(e = null == e ? 9007199254740991 : e) && ("number" == r || "symbol" != r && Co.test(t)) && t > -1 && t % 1 == 0 && t < e;
};
var No = function No(t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
  },
  Mo = qt,
  Do = No,
  Fo = Lt,
  Uo = {};
Uo["[object Float32Array]"] = Uo["[object Float64Array]"] = Uo["[object Int8Array]"] = Uo["[object Int16Array]"] = Uo["[object Int32Array]"] = Uo["[object Uint8Array]"] = Uo["[object Uint8ClampedArray]"] = Uo["[object Uint16Array]"] = Uo["[object Uint32Array]"] = !0, Uo["[object Arguments]"] = Uo["[object Array]"] = Uo["[object ArrayBuffer]"] = Uo["[object Boolean]"] = Uo["[object DataView]"] = Uo["[object Date]"] = Uo["[object Error]"] = Uo["[object Function]"] = Uo["[object Map]"] = Uo["[object Number]"] = Uo["[object Object]"] = Uo["[object RegExp]"] = Uo["[object Set]"] = Uo["[object String]"] = Uo["[object WeakMap]"] = !1;
var zo = function zo(t) {
  return Fo(t) && Do(t.length) && !!Uo[Mo(t)];
};
var Vo = function Vo(t) {
    return function (e) {
      return t(e);
    };
  },
  Bo = {
    exports: {}
  };
!function (t, e) {
  var r = It,
    n = e && !e.nodeType && e,
    o = n && t && !t.nodeType && t,
    a = o && o.exports === n && r.process,
    i = function () {
      try {
        var t = o && o.require && o.require("util").types;
        return t || a && a.binding && a.binding("util");
      } catch (t) {}
    }();
  t.exports = i;
}(Bo, Bo.exports);
var qo = zo,
  Lo = Vo,
  Wo = Bo.exports,
  Jo = Wo && Wo.isTypedArray,
  Ko = Jo ? Lo(Jo) : qo,
  Go = Oo,
  Ho = Po,
  Yo = At,
  Qo = ko.exports,
  Zo = $o,
  Xo = Ko,
  ta = Object.prototype.hasOwnProperty;
var ea = function ea(t, e) {
    var r = Yo(t),
      n = !r && Ho(t),
      o = !r && !n && Qo(t),
      a = !r && !n && !o && Xo(t),
      i = r || n || o || a,
      u = i ? Go(t.length, String) : [],
      c = u.length;
    for (var s in t) {
      !e && !ta.call(t, s) || i && ("length" == s || o && ("offset" == s || "parent" == s) || a && ("buffer" == s || "byteLength" == s || "byteOffset" == s) || Zo(s, c)) || u.push(s);
    }
    return u;
  },
  ra = Object.prototype;
var na = function na(t) {
  var e = t && t.constructor;
  return t === ("function" == typeof e && e.prototype || ra);
};
var oa = function oa(t, e) {
    return function (r) {
      return t(e(r));
    };
  },
  aa = oa(Object.keys, Object),
  ia = na,
  ua = aa,
  ca = Object.prototype.hasOwnProperty;
var sa = ne,
  fa = No;
var la = function la(t) {
    return null != t && fa(t.length) && !sa(t);
  },
  pa = ea,
  ya = function ya(t) {
    if (!ia(t)) return ua(t);
    var e = [];
    for (var r in Object(t)) {
      ca.call(t, r) && "constructor" != r && e.push(r);
    }
    return e;
  },
  va = la;
var da = function da(t) {
    return va(t) ? pa(t) : ya(t);
  },
  ba = wo,
  ha = da;
var ma = function ma(t, e) {
  return t && ba(e, ha(e), t);
};
var ga = Xt,
  ja = na,
  wa = function wa(t) {
    var e = [];
    if (null != t) for (var r in Object(t)) {
      e.push(r);
    }
    return e;
  },
  Oa = Object.prototype.hasOwnProperty;
var xa = ea,
  Sa = function Sa(t) {
    if (!ga(t)) return wa(t);
    var e = ja(t),
      r = [];
    for (var n in t) {
      ("constructor" != n || !e && Oa.call(t, n)) && r.push(n);
    }
    return r;
  },
  _a = la;
var Ea = function Ea(t) {
    return _a(t) ? xa(t, !0) : Sa(t);
  },
  Aa = wo,
  Ia = Ea;
var Ta = function Ta(t, e) {
    return t && Aa(e, Ia(e), t);
  },
  Pa = {
    exports: {}
  };
!function (t, e) {
  var r = kt,
    n = e && !e.nodeType && e,
    o = n && t && !t.nodeType && t,
    a = o && o.exports === n ? r.Buffer : void 0,
    i = a ? a.allocUnsafe : void 0;
  t.exports = function (t, e) {
    if (e) return t.slice();
    var r = t.length,
      n = i ? i(r) : new t.constructor(r);
    return t.copy(n), n;
  };
}(Pa, Pa.exports);
var ka = function ka(t, e) {
  var r = -1,
    n = t.length;
  for (e || (e = Array(n)); ++r < n;) {
    e[r] = t[r];
  }
  return e;
};
var Ra = function Ra() {
    return [];
  },
  Ca = function Ca(t, e) {
    for (var r = -1, n = null == t ? 0 : t.length, o = 0, a = []; ++r < n;) {
      var i = t[r];
      e(i, r, t) && (a[o++] = i);
    }
    return a;
  },
  $a = Ra,
  Na = Object.prototype.propertyIsEnumerable,
  Ma = Object.getOwnPropertySymbols,
  Da = Ma ? function (t) {
    return null == t ? [] : (t = Object(t), Ca(Ma(t), function (e) {
      return Na.call(t, e);
    }));
  } : $a,
  Fa = wo,
  Ua = Da;
var za = function za(t, e) {
  return Fa(t, Ua(t), e);
};
var Va = function Va(t, e) {
    for (var r = -1, n = e.length, o = t.length; ++r < n;) {
      t[o + r] = e[r];
    }
    return t;
  },
  Ba = oa(Object.getPrototypeOf, Object),
  qa = Va,
  La = Ba,
  Wa = Da,
  Ja = Ra,
  Ka = Object.getOwnPropertySymbols ? function (t) {
    for (var e = []; t;) {
      qa(e, Wa(t)), t = La(t);
    }
    return e;
  } : Ja,
  Ga = wo,
  Ha = Ka;
var Ya = function Ya(t, e) {
    return Ga(t, Ha(t), e);
  },
  Qa = Va,
  Za = At;
var Xa = function Xa(t, e, r) {
    var n = e(t);
    return Za(t) ? n : Qa(n, r(t));
  },
  ti = Xa,
  ei = Da,
  ri = da;
var ni = function ni(t) {
    return ti(t, ri, ei);
  },
  oi = Xa,
  ai = Ka,
  ii = Ea;
var ui = function ui(t) {
    return oi(t, ii, ai);
  },
  ci = we(kt, "DataView"),
  si = er,
  fi = we(kt, "Promise"),
  li = we(kt, "Set"),
  pi = we(kt, "WeakMap"),
  yi = qt,
  vi = ce,
  di = vi(ci),
  bi = vi(si),
  hi = vi(fi),
  mi = vi(li),
  gi = vi(pi),
  ji = yi;
(ci && "[object DataView]" != ji(new ci(new ArrayBuffer(1))) || si && "[object Map]" != ji(new si()) || fi && "[object Promise]" != ji(fi.resolve()) || li && "[object Set]" != ji(new li()) || pi && "[object WeakMap]" != ji(new pi())) && (ji = function ji(t) {
  var e = yi(t),
    r = "[object Object]" == e ? t.constructor : void 0,
    n = r ? vi(r) : "";
  if (n) switch (n) {
    case di:
      return "[object DataView]";
    case bi:
      return "[object Map]";
    case hi:
      return "[object Promise]";
    case mi:
      return "[object Set]";
    case gi:
      return "[object WeakMap]";
  }
  return e;
});
var wi = ji,
  Oi = Object.prototype.hasOwnProperty;
var xi = function xi(t) {
    var e = t.length,
      r = new t.constructor(e);
    return e && "string" == typeof t[0] && Oi.call(t, "index") && (r.index = t.index, r.input = t.input), r;
  },
  Si = kt.Uint8Array;
var _i = function _i(t) {
    var e = new t.constructor(t.byteLength);
    return new Si(e).set(new Si(t)), e;
  },
  Ei = _i;
var Ai = function Ai(t, e) {
    var r = e ? Ei(t.buffer) : t.buffer;
    return new t.constructor(r, t.byteOffset, t.byteLength);
  },
  Ii = /\w*$/;
var Ti = function Ti(t) {
    var e = new t.constructor(t.source, Ii.exec(t));
    return e.lastIndex = t.lastIndex, e;
  },
  Pi = Rt ? Rt.prototype : void 0,
  ki = Pi ? Pi.valueOf : void 0;
var Ri = _i;
var Ci = _i,
  $i = Ai,
  Ni = Ti,
  Mi = function Mi(t) {
    return ki ? Object(ki.call(t)) : {};
  },
  Di = function Di(t, e) {
    var r = e ? Ri(t.buffer) : t.buffer;
    return new t.constructor(r, t.byteOffset, t.length);
  };
var Fi = function Fi(t, e, r) {
    var n = t.constructor;
    switch (e) {
      case "[object ArrayBuffer]":
        return Ci(t);
      case "[object Boolean]":
      case "[object Date]":
        return new n(+t);
      case "[object DataView]":
        return $i(t, r);
      case "[object Float32Array]":
      case "[object Float64Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object Int32Array]":
      case "[object Uint8Array]":
      case "[object Uint8ClampedArray]":
      case "[object Uint16Array]":
      case "[object Uint32Array]":
        return Di(t, r);
      case "[object Map]":
      case "[object Set]":
        return new n();
      case "[object Number]":
      case "[object String]":
        return new n(t);
      case "[object RegExp]":
        return Ni(t);
      case "[object Symbol]":
        return Mi(t);
    }
  },
  Ui = Xt,
  zi = Object.create,
  Vi = function () {
    function t() {}
    return function (e) {
      if (!Ui(e)) return {};
      if (zi) return zi(e);
      t.prototype = e;
      var r = new t();
      return t.prototype = void 0, r;
    };
  }(),
  Bi = Ba,
  qi = na;
var Li = function Li(t) {
    return "function" != typeof t.constructor || qi(t) ? {} : Vi(Bi(t));
  },
  Wi = wi,
  Ji = Lt;
var Ki = function Ki(t) {
    return Ji(t) && "[object Map]" == Wi(t);
  },
  Gi = Vo,
  Hi = Bo.exports,
  Yi = Hi && Hi.isMap,
  Qi = Yi ? Gi(Yi) : Ki,
  Zi = wi,
  Xi = Lt;
var tu = function tu(t) {
    return Xi(t) && "[object Set]" == Zi(t);
  },
  eu = Vo,
  ru = Bo.exports,
  nu = ru && ru.isSet,
  ou = nu ? eu(nu) : tu,
  au = co,
  iu = so,
  uu = mo,
  cu = ma,
  su = Ta,
  fu = Pa.exports,
  lu = ka,
  pu = za,
  yu = Ya,
  vu = ni,
  du = ui,
  bu = wi,
  hu = xi,
  mu = Fi,
  gu = Li,
  ju = At,
  wu = ko.exports,
  Ou = Qi,
  xu = Xt,
  Su = ou,
  _u = da,
  Eu = Ea,
  Au = {};
Au["[object Arguments]"] = Au["[object Array]"] = Au["[object ArrayBuffer]"] = Au["[object DataView]"] = Au["[object Boolean]"] = Au["[object Date]"] = Au["[object Float32Array]"] = Au["[object Float64Array]"] = Au["[object Int8Array]"] = Au["[object Int16Array]"] = Au["[object Int32Array]"] = Au["[object Map]"] = Au["[object Number]"] = Au["[object Object]"] = Au["[object RegExp]"] = Au["[object Set]"] = Au["[object String]"] = Au["[object Symbol]"] = Au["[object Uint8Array]"] = Au["[object Uint8ClampedArray]"] = Au["[object Uint16Array]"] = Au["[object Uint32Array]"] = !0, Au["[object Error]"] = Au["[object Function]"] = Au["[object WeakMap]"] = !1;
var Iu = function t(e, r, n, o, a, i) {
  var u,
    c = 1 & r,
    s = 2 & r,
    f = 4 & r;
  if (n && (u = a ? n(e, o, a, i) : n(e)), void 0 !== u) return u;
  if (!xu(e)) return e;
  var l = ju(e);
  if (l) {
    if (u = hu(e), !c) return lu(e, u);
  } else {
    var p = bu(e),
      y = "[object Function]" == p || "[object GeneratorFunction]" == p;
    if (wu(e)) return fu(e, c);
    if ("[object Object]" == p || "[object Arguments]" == p || y && !a) {
      if (u = s || y ? {} : gu(e), !c) return s ? yu(e, su(u, e)) : pu(e, cu(u, e));
    } else {
      if (!Au[p]) return a ? e : {};
      u = mu(e, p, c);
    }
  }
  i || (i = new au());
  var v = i.get(e);
  if (v) return v;
  i.set(e, u), Su(e) ? e.forEach(function (o) {
    u.add(t(o, r, n, o, e, i));
  }) : Ou(e) && e.forEach(function (o, a) {
    u.set(a, t(o, r, n, a, e, i));
  });
  var d = l ? void 0 : (f ? s ? du : vu : s ? Eu : _u)(e);
  return iu(d || e, function (o, a) {
    d && (o = e[a = o]), uu(u, a, t(o, r, n, a, e, i));
  }), u;
};
var Tu = Vr,
  Pu = function Pu(t, e, r) {
    var n = -1,
      o = t.length;
    e < 0 && (e = -e > o ? 0 : o + e), (r = r > o ? o : r) < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
    for (var a = Array(o); ++n < o;) {
      a[n] = t[n + e];
    }
    return a;
  };
var ku = Mr,
  Ru = function Ru(t) {
    var e = null == t ? 0 : t.length;
    return e ? t[e - 1] : void 0;
  },
  Cu = function Cu(t, e) {
    return e.length < 2 ? t : Tu(t, Pu(e, 0, -1));
  },
  $u = Fr;
var Nu = function Nu(t, e) {
    return e = ku(e, t), null == (t = Cu(t, e)) || delete t[$u(Ru(e))];
  },
  Mu = qt,
  Du = Ba,
  Fu = Lt,
  Uu = Function.prototype,
  zu = Object.prototype,
  Vu = Uu.toString,
  Bu = zu.hasOwnProperty,
  qu = Vu.call(Object);
var Lu = function Lu(t) {
  if (!Fu(t) || "[object Object]" != Mu(t)) return !1;
  var e = Du(t);
  if (null === e) return !0;
  var r = Bu.call(e, "constructor") && e.constructor;
  return "function" == typeof r && r instanceof r && Vu.call(r) == qu;
};
var Wu = function Wu(t) {
    return Lu(t) ? void 0 : t;
  },
  Ju = Po,
  Ku = At,
  Gu = Rt ? Rt.isConcatSpreadable : void 0;
var Hu = Va,
  Yu = function Yu(t) {
    return Ku(t) || Ju(t) || !!(Gu && t && t[Gu]);
  };
var Qu = function t(e, r, n, o, a) {
    var i = -1,
      u = e.length;
    for (n || (n = Yu), a || (a = []); ++i < u;) {
      var c = e[i];
      r > 0 && n(c) ? r > 1 ? t(c, r - 1, n, o, a) : Hu(a, c) : o || (a[a.length] = c);
    }
    return a;
  },
  Zu = Qu;
var Xu = function Xu(t) {
  return (null == t ? 0 : t.length) ? Zu(t, 1) : [];
};
var tc = function tc(t, e, r) {
    switch (r.length) {
      case 0:
        return t.call(e);
      case 1:
        return t.call(e, r[0]);
      case 2:
        return t.call(e, r[0], r[1]);
      case 3:
        return t.call(e, r[0], r[1], r[2]);
    }
    return t.apply(e, r);
  },
  ec = Math.max;
var rc = function rc(t, e, r) {
  return e = ec(void 0 === e ? t.length - 1 : e, 0), function () {
    for (var n = arguments, o = -1, a = ec(n.length - e, 0), i = Array(a); ++o < a;) {
      i[o] = n[e + o];
    }
    o = -1;
    for (var u = Array(e + 1); ++o < e;) {
      u[o] = n[o];
    }
    return u[e] = r(i), tc(t, this, u);
  };
};
var nc = function nc(t) {
    return function () {
      return t;
    };
  },
  oc = lo,
  ac = oc ? function (t, e) {
    return oc(t, "toString", {
      configurable: !0,
      enumerable: !1,
      value: nc(e),
      writable: !0
    });
  } : function (t) {
    return t;
  },
  ic = Date.now;
var uc = function (t) {
    var e = 0,
      r = 0;
    return function () {
      var n = ic(),
        o = 16 - (n - r);
      if (r = n, o > 0) {
        if (++e >= 800) return arguments[0];
      } else e = 0;
      return t.apply(void 0, arguments);
    };
  }(ac),
  cc = Xu,
  sc = rc,
  fc = uc;
var lc = Sr,
  pc = Iu,
  yc = Nu,
  vc = Mr,
  dc = wo,
  bc = Wu,
  hc = ui,
  mc = function (t) {
    return fc(sc(t, void 0, cc), t + "");
  }(function (t, e) {
    var r = {};
    if (null == t) return r;
    var n = !1;
    e = lc(e, function (e) {
      return e = vc(e, t), n || (n = e.length > 1), e;
    }), dc(t, hc(t), r), n && (r = pc(r, 7, bc));
    for (var o = e.length; o--;) {
      yc(r, e[o]);
    }
    return r;
  }),
  gc = ["beforeFetch", "request", "shouldHideError", "shouldContinueNextApiOnError", "condition"],
  jc = gc[0],
  wc = gc[1],
  Oc = gc[2],
  xc = gc[3],
  Sc = gc[4],
  _c = ["POST", "GET", "PUT", "PATCH", "DELETE"],
  Ec = _c[0],
  Ac = _c[1],
  Ic = _c[2],
  Tc = _c[3],
  Pc = _c[4],
  kc = {
    api: {},
    error: [],
    continueNextApi: !0
  },
  Rc = function () {
    var t = y(_regeneratorRuntime.mark(function t(e) {
      var r, n, o, a, i, u, c, s, l, p;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (r = e.api, n = void 0 === r ? {} : r, o = e.all, a = void 0 === o ? {} : o, i = e.componentsToMap, u = void 0 === i ? {} : i, c = e.helpers, s = void 0 === c ? {} : c, n) {
                t.next = 3;
                break;
              }
              return t.abrupt("return", kc);
            case 3:
              return l = Cc(a), t.next = 6, Object.keys(n).reduce(function () {
                var t = y(_regeneratorRuntime.mark(function t(e, r) {
                  var o, a, i, c, p;
                  return _regeneratorRuntime.wrap(function (t) {
                    for (;;) {
                      switch (t.prev = t.next) {
                        case 0:
                          return t.next = 2, e;
                        case 2:
                          if (o = t.sent, a = o.api, !o.continueNextApi) {
                            t.next = 11;
                            break;
                          }
                          return i = f(f({}, l), {}, {
                            api: f(f({}, n), a)
                          }), c = n[r], t.next = 9, Nc({
                            apiConfig: c,
                            apiKey: r,
                            allInput: i,
                            componentsToMap: u,
                            allResults: o,
                            helpers: s
                          });
                        case 9:
                          return p = t.sent, t.abrupt("return", p);
                        case 11:
                          return t.abrupt("return", o);
                        case 12:
                        case "end":
                          return t.stop();
                      }
                    }
                  }, t);
                }));
                return function (e, r) {
                  return t.apply(this, arguments);
                };
              }(), kc);
            case 6:
              return p = t.sent, t.abrupt("return", mc(p, "continueNextApi"));
            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
  Cc = function Cc(t) {
    return f({
      qs: Kr()
    }, t);
  },
  $c = function $c(t) {
    return new URL(t).origin;
  },
  Nc = function () {
    var t = y(_regeneratorRuntime.mark(function t(e) {
      var r, n, o, a, i, u, c, s, l, p, y, v, d, b, h;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (r = e.apiConfig, n = void 0 === r ? {} : r, o = e.allInput, a = e.helpers, i = n.method, u = n[wc], c = n.headers, s = n.url, l = n[jc], p = Dc(l, o), t.prev = 4, !Mc(i)) {
                t.next = 7;
                break;
              }
              return t.abrupt("return", n);
            case 7:
              if (y = qc({
                headers: c,
                request: u,
                url: s
              }, p, a), v = Lc(y, n), d = v.url, b = v.options, !window || !window.mockEnabled || "function" != typeof window.fetchMock) {
                t.next = 15;
                break;
              }
              return t.next = 12, window.fetchMock(encodeURI(d), b, $c(d), !0);
            case 12:
              t.t0 = t.sent, t.next = 18;
              break;
            case 15:
              return t.next = 17, fetch(encodeURI(d), b);
            case 17:
              t.t0 = t.sent;
            case 18:
              return h = t.t0, t.abrupt("return", Wc(f(f({}, e), {}, {
                response: h,
                allInput: p
              })));
            case 22:
              return t.prev = 22, t.t1 = t.catch(4), t.abrupt("return", Wc(f(f({}, e), {}, {
                response: t.t1,
                allInput: p
              })));
            case 25:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[4, 22]]);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
  Mc = function Mc(t) {
    return !1 === _c.includes(t);
  },
  Dc = function Dc(t, e) {
    var r = Fc(t, e);
    return tn(r) ? e : f(f({}, e), {}, {
      beforeFetch: r
    });
  },
  Fc = function Fc(t, e, r) {
    if (!t) return t;
    var n = Uc(t, e);
    return Bc(n, r);
  },
  Uc = function Uc(t, e) {
    if (!t) return "";
    var r = en(t).split("{"),
      n = "";
    return r.forEach(function (t, r) {
      var o = zc(t, r, e);
      n = "".concat(n).concat(o);
    }), n.replace(Vc, function (t) {
      return t.replace(/[\\"|\\']/, "");
    });
  },
  zc = function zc(t, e, r) {
    var n = t.indexOf("}"),
      o = t.substring(0, n),
      a = t.substring(n + 1),
      i = qr(r, o);
    if (void 0 !== i) {
      var u = en(i);
      return a ? "".concat(u).concat(a) : u;
    }
    var c = t;
    return e >= 1 && (c = "{" + t), c;
  },
  Vc = /[\\"|\\'](\[)|(\])[\\"|\\']|[\\"|\\']({)|(})[\\"|\\']/g,
  Bc = function Bc(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    try {
      var r = en(t),
        n = g(Function, S(Object.keys(e)).concat(["return " + r])),
        o = n.apply(void 0, S(Object.values(e)));
      return o;
    } catch (e) {
      return t;
    }
  },
  qc = function qc(t, e, r) {
    var n = Cc(e);
    return Object.keys(t).reduce(function (e, o) {
      return f(f({}, e), {}, d({}, o, Fc(t[o], n, r)));
    }, {});
  },
  Lc = function Lc(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = t.request,
      n = t.url,
      o = t.headers,
      a = void 0 === o ? null : o,
      i = JSON.parse(en(a)) || {},
      u = e.method,
      c = f(f({}, mc(e, gc, "url")), {}, {
        headers: i
      }),
      s = {
        url: n,
        options: c
      };
    if (!r) return s;
    switch (u) {
      case Ec:
      case Ic:
      case Tc:
        return {
          url: n,
          options: f(f({}, c), {}, {
            body: "string" == typeof r ? r : JSON.stringify(r)
          })
        };
      case Pc:
      case Ac:
        var l = "string" == typeof r ? r : rn(r);
        return {
          options: c,
          url: "".concat(n, "?").concat(l)
        };
      default:
        return s;
    }
  },
  Wc = function () {
    var t = y(_regeneratorRuntime.mark(function t(e) {
      var r, n, o, a, i, u, c, s, l, p, y, v, b, h;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (r = e.response, n = e.apiConfig, o = e.allInput, a = e.apiKey, i = e.allResults, u = i.api, c = r.ok, s = r.status, l = n[Sc], t.prev = 4, "boolean" != typeof c || !s) {
                t.next = 16;
                break;
              }
              return t.next = 8, r.json();
            case 8:
              if (p = t.sent, y = f(f({}, o), {}, {
                api: f(f({}, u), {}, d({}, a, f({}, p)))
              }, p), v = Jc(l), b = Uc(v, y), !Kc({
                ok: c,
                condition: l,
                errKey: v,
                errVal: b,
                status: s
              })) {
                t.next = 15;
                break;
              }
              return h = Qc(f(f({}, e), {}, {
                errVal: b,
                status: s,
                allInput: y
              })), t.abrupt("return", h);
            case 15:
              return t.abrupt("return", f(f({}, i), {}, {
                continueNextApi: !0,
                api: f(f({}, u), {}, d({}, a, f({}, p)))
              }));
            case 16:
              return t.abrupt("return", Qc(f(f({}, e), {}, {
                status: s
              })));
            case 19:
              return t.prev = 19, t.t0 = t.catch(4), t.abrupt("return", Qc(f(f({}, e), {}, {
                status: s
              })));
            case 22:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[4, 19]]);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
  Jc = function Jc() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      e = t.key;
    return e;
  },
  Kc = function Kc(t) {
    var e = t.condition,
      r = t.errKey,
      n = t.errVal,
      o = t.status;
    return Gc(r) && r === n ? Yc(e, o) : Gc(r) && Yc(e, n) || Hc(r) && Yc(e, o);
  },
  Gc = function Gc(t) {
    return void 0 !== t;
  },
  Hc = function Hc(t) {
    return void 0 === t;
  },
  Yc = function Yc(t, e) {
    return !0 !== (t && e && qr(t, "".concat(e, ".continue")));
  },
  Qc = function Qc(t) {
    var e = t.status,
      r = t.allResults,
      n = t.apiConfig,
      o = t.errVal,
      a = r.error,
      i = n[Oc],
      u = n[xc],
      c = n[Sc],
      s = u || false;
    if (i || false) return f(f({}, r), {}, {
      continueNextApi: s
    });
    var l = c[o] || c[e] || c.default,
      p = Zc(f(f({}, t), {}, {
        currentAction: l
      }));
    return f(f({}, r), {}, {
      error: [].concat(S(a), S(p)),
      continueNextApi: s
    });
  },
  Zc = function Zc(t) {
    var e = t.currentAction,
      r = void 0 === e ? {} : e,
      n = t.componentsToMap,
      o = t.allInput,
      a = [];
    if (r) {
      var i = r.redirect,
        u = r.render,
        c = r.message;
      if (i || c) {
        var s = i ? "redirect" : "message";
        a = [d({}, s, Fc(r[s], o))];
      }
      u && (a = [{
        render: Gn(u, n, o)
      }]);
    }
    return a;
  },
  Xc = function Xc() {
    var t = r(!1);
    return n(function () {
      return t.current = !0, function () {
        t.current = !1;
      };
    }, []), t;
  },
  ts = function ts(t) {
    return o(t) || Array.isArray(t) || "object" !== l(t);
  },
  es = function es(t) {
    var e = t.whenLoading,
      r = function (t) {
        var e = O(a(!1), 2),
          r = e[0],
          o = e[1],
          i = O(a(t), 1)[0],
          u = O(a(null), 2),
          c = u[0],
          s = u[1],
          f = Xc(),
          l = i.api,
          p = i.whenSuccess,
          v = i.whenError,
          d = i.dataToMap,
          b = i.componentsToMap,
          h = i.helpers;
        return n(function () {
          y(_regeneratorRuntime.mark(function t() {
            var e, r, n, a, u, c, y, m;
            return _regeneratorRuntime.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return o(!1), t.prev = 1, t.next = 4, Rc({
                      api: l,
                      all: d,
                      componentsToMap: b,
                      helpers: h
                    });
                  case 4:
                    e = t.sent, r = e.api, (n = e.error).length > 0 ? (a = n[0], u = a.redirect, c = a.render, y = a.message, u && Jr ? window.location.assign(u) : y ? v && v(y) : f.current && o(c)) : p && (m = p(r, i)) && f.current && s(m), t.next = 12;
                    break;
                  case 9:
                    t.prev = 9, t.t0 = t.catch(1), f.current && o(t.t0);
                  case 12:
                  case "end":
                    return t.stop();
                }
              }
            }, t, null, [[1, 9]]);
          }))();
        }, [i]), {
          error: r,
          result: c
        };
      }(t),
      o = r.error,
      i = r.result;
    if (o) return ts(o) ? o : null;
    if (i) return ts(i) ? i : null;
    var u = e(t);
    return ts(u) ? u : null;
  };
es.propTypes = {
  api: Et.object.isRequired,
  whenSuccess: Et.func.isRequired,
  whenLoading: Et.func.isRequired,
  whenError: Et.func,
  componentsToMap: Et.object,
  dataToMap: Et.object.isRequired,
  helpers: Et.object
};
var rs = "ss360SearchBox",
  ns = {
    siteId: "www.singtel.com_1",
    showErrors: "development" === process.env.NODE_ENV,
    layout: {
      navigation: {
        position: "top"
      }
    },
    suggestions: {
      highlight: !1
    },
    style: {
      themeColor: "#000000",
      suggestions: {
        text: {
          color: "#000000"
        },
        background: {
          color: "#ffffff"
        },
        distanceFromTop: "7px",
        border: {
          color: "#dddddd",
          radius: "7px"
        }
      },
      searchBox: {
        text: {
          color: "#000000",
          size: "1rem"
        },
        background: {
          color: "#ffffff"
        },
        padding: "10px",
        border: {
          color: "#3D393A",
          radius: "7px"
        }
      }
    },
    searchBox: {
      placeholder: "Search",
      selector: ".".concat("ss360SearchBox")
    },
    results: {
      embedConfig: {
        contentBlock: "#searchResults",
        url: "https://cdn.aws.singtel.com/search/search.html"
      },
      caption: "We found #COUNT# results for your query '#QUERY#'",
      num: 200,
      searchQueryParamName: "rinput",
      moreResultsPagingSize: 50
    },
    contentGroups: {
      otherName: "Other"
    },
    specialMobileSuggest: {
      enabled: !1
    }
  },
  os = function os() {
    var t;
    void 0 === window.ss360Config ? ((t = document.createElement("script")).type = "text/javascript", t.async = !0, t.defer = !0, window.ss360Config = ns, t.src = "https://cdn.sitesearch360.com/sitesearch360-v11.min.js", document.getElementsByTagName("head")[0].appendChild(t)) : void 0 !== window.SS360 && window.SS360.init();
  },
  as = function as() {
    for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.cookie, e = t.split(";"), r = {}, n = 0; e.length > n; n++) {
      var o = e[n].trim().split("=");
      Object.assign(r, d({}, o[0], o[1]));
    }
    return r;
  },
  is = function is(t) {
    for (var e = t + "=", r = document.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var o = r[n]; " " == o.charAt(0);) {
        o = o.substring(1, o.length);
      }
      if (0 == o.indexOf(e)) return o.substring(e.length, o.length);
    }
    return null;
  },
  us = function us(t, e, r) {
    var n = "".concat(t, "=").concat(e),
      o = r && r.expires ? "expires=".concat(r.expires.toUTCString()) : "",
      a = r && r.domain ? "domain=".concat(r.domain) : "",
      i = r && r.maxAge ? "max-age=".concat(r.maxAge) : "",
      u = r && r.secure ? "secure" : "";
    document.cookie = [n, i, o, a, u].filter(Boolean).join(";");
  },
  cs = function cs(t, e, r) {
    us(t, JSON.stringify(e), r);
  },
  ss = function ss(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document.cookie,
      r = as(e),
      n = r[t];
    if (n) try {
      return JSON.parse(n);
    } catch (t) {
      return;
    }
  },
  fs = function fs() {
    try {
      return window.self !== window.top;
    } catch (t) {
      return !0;
    }
  },
  ls = function ls(t) {
    return /^([a-z0-9_\-.+]{2,100})@([a-z0-9\-.]{2,})\.([a-z0-9]{2,})$/i.test(t);
  },
  ps = function ps(t) {
    return /^[689][0-9]{7}$/.test(t);
  },
  ys = function ys(t) {
    return /^[89][0-9]{7}$/.test(t);
  },
  vs = function vs(t) {
    return /^[a-zA-Z\s]+$/.test(t);
  },
  ds = function ds(t) {
    return /^[a-z0-9]+$/i.test(t);
  },
  bs = function bs(t) {
    if (9 !== t.length) return !1;
    t = t.toUpperCase();
    for (var e = [], r = 0; r < 9; r++) {
      e[r] = t.charAt(r);
    }
    e[1] = 2 * parseInt(e[1], 10), e[2] = 7 * parseInt(e[2], 10), e[3] = 6 * parseInt(e[3], 10), e[4] = 5 * parseInt(e[4], 10), e[5] = 4 * parseInt(e[5], 10), e[6] = 3 * parseInt(e[6], 10), e[7] = 2 * parseInt(e[7], 10);
    for (var n = 0, o = 1; o < 8; o++) {
      n += parseInt(e[o], 10);
    }
    var a,
      i = "M" === e[0],
      u = (("T" === e[0] || "G" === e[0] ? 4 : i ? 3 : 0) + n) % 11,
      c = ["X", "W", "U", "T", "R", "Q", "P", "N", i ? "J" : "M", "L", "K"];
    return "S" === e[0] || "T" === e[0] ? a = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"][u] : ("F" === e[0] || "G" === e[0] || i) && (a = c[u]), e[8] === a;
  },
  hs = function hs(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : " ",
      n = [];
    return "string" == typeof t && t.split(r).forEach(function (t, o, a) {
      n.push(e[t] || t), o < a.length - 1 && n.push(r);
    }), n;
  },
  ms = "undefined" != typeof window,
  gs = function gs(t, e) {
    ms && window.localStorage.setItem(t, e);
  },
  js = function js(t) {
    return ms && window.localStorage.getItem(t) || "en";
  },
  ws = function ws(t, e) {
    return t[e];
  },
  Os = function Os(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = {},
      n = Object.keys(e),
      a = !1;
    if (n.forEach(function (t) {
      !a && o(e[t]) && (a = !0), r["{" + t + "}"] = e[t];
    }), a) {
      var c = hs(t, r);
      return u(i, {
        children: c.map(function (t, e) {
          return u(i, {
            children: t
          }, e);
        })
      });
    }
    if (n.length) {
      var s = "(" + n.map(function (t) {
          return "\\{" + t + "}";
        }).join("|") + ")",
        f = new RegExp(s, "g");
      return t.replace(f, function (t) {
        return r[t];
      });
    }
    return t;
  },
  xs = "windows",
  Ss = "android",
  _s = "ios",
  Es = function Es() {
    var t = navigator.userAgent || navigator.vendor || window.opera;
    return /windows phone/i.test(t) ? "windows" : /android/i.test(t) ? "android" : /iPad|iPhone|iPod/.test(t) && !window.MSStream ? "ios" : "";
  };
export { Ss as ANDROID_OS, Yn as DynamicComponent, es as HandleApi, _s as IOS, xs as WINDOWS_OS, un as adjustContrast, en as convertToString, yn as debounce, qc as executeValues, Gr as findAndReplacePlaceHolder, Rc as getAPIResponse, Zr as getAllComponents, as as getAllCookies, is as getCookie, ss as getJsonCookie, js as getLocale, ws as getLocaleData, Es as getMobileOperatingSystem, cn as getUrlParams, on as hexToRGBA, os as initializeSiteSearch360, Jr as isBrowser, fn as isEnterKey, ln as isEscapeKey, fs as isIFrame, tn as isNotObject, Xr as isObject, pn as isUrlAbsolute, ds as isValidAlphaNumericNoSpace, vs as isValidAlphaWithSpace, ls as isValidEmail, ps as isValidMobileLandNumber, ys as isValidMobileNumber, bs as isValidNric, dn as noop, Kr as parseQueryString, nn as remCalc, Hr as replacePlaceHolderWith, Yr as replacePlaceHolderWithQueryString, Vn as replacePlaceholderWithUserInput, an as rgbaToHex, vn as safeParse, rn as serializeObject, us as setCookie, cs as setJsonCookie, gs as setLocale, sn as setUrlParams, rs as siteSearch360InputClassName, Os as translate, Xc as useIsMounted };